import dayjs, { Dayjs } from 'dayjs'
import { StateCreator } from 'zustand'
import { WorkforceSharedSlice } from '../slice'

export type ApprovalsFilter = {
  requestType: string | null
  role: string | null
  staff: string | null
  status: string | null
  requestsFrom: Dayjs
  requestsTo: Dayjs
}
interface ApprovalsState {
  approvalsFilters: ApprovalsFilter
  /** Key of the active approvals tab; drives which Request type options are shown. */
  activeApprovalsTab: string
}

export interface ApprovalsSlice extends ApprovalsState {
  /**
   * Set the approvals page filters
   * @param filters the filters to set
   */
  setApprovalsFilter: (filters: ApprovalsFilter) => void
  /**
   * Set the active approvals tab. Clears the request type filter, whose options differ per tab.
   * @param tab the key of the tab now active
   */
  setActiveApprovalsTab: (tab: string) => void
}

const initialState: ApprovalsState = {
  approvalsFilters: {
    requestType: null,
    role: null,
    staff: null,
    status: null,
    requestsFrom: dayjs().subtract(1, 'month').startOf('day'),
    requestsTo: dayjs().endOf('day'),
  },
  activeApprovalsTab: 'requests',
}

const createApprovalsSlice: StateCreator<
  ApprovalsSlice & WorkforceSharedSlice,
  [],
  [],
  ApprovalsSlice
> = (set) => ({
  ...initialState,

  setApprovalsFilter: (filters: ApprovalsFilter) => {
    set(() => ({
      approvalsFilters: filters,
    }))
  },

  setActiveApprovalsTab: (tab: string) => {
    set((state) => ({
      activeApprovalsTab: tab,
      approvalsFilters: { ...state.approvalsFilters, requestType: null },
    }))
  },
})

export default createApprovalsSlice
